import config from "../config"
const baseUrl = config.base_url + "ai/image/"
export default {
    recognize: {
        url: baseUrl + "recognize",
        type: "post",
    },
    recognizeStream: {
        url: baseUrl + "recognize/stream",
        type: "post",
    }
}

